import { useEffect, useState } from 'react'
import moment from 'moment'

import Menu from '../../components/Menu'
import './Dashboard.css'
import DataCard from '../../components/DataCard'
import Clients from '../../assets/img/clients-im.svg'
import Agreements from '../../assets/img/plano-de-saude.svg'
import Doctor from '../../assets/img/doctor.svg'
import Shortcuts from '../../components/Shortcuts'
import LineChart from '../../components/LineChart'
import posConsult from '../../assets/img/PosConsultorioWhite.svg'
import ListCardAgreements from '../../components/ListCardAgreements'
import Hospital from '../../assets/img/hospital.svg'
import api from '../../api'
import { useStateContext } from '../../contexts/ContextProvider'
import ListCardProfessionalsLoggedIn from '../../components/ListCardProfessionalsLoggedIn'
export default function Dashboard() {
  const { hasRole } = useStateContext();

  const [customers, setCustomers] = useState(0)
  const [customersVeri, setCustomersVeri] = useState(0)

  const [professionals, setProfessionals] = useState(0)
  const [agreements, setAgreements] = useState(0)

  const currentYear = moment().format('YYYY');

  const [customersData, setCustomersData] = useState(null)
  const [shoppersData, setShoppersData] = useState(null)

  const getGraphicsData = (data) => {
    const monthsOrder = [
      "january", "february", "march", "april", "may", "june",
      "july", "august", "september", "october", "november", "december"
    ];

    const customers = monthsOrder.map(month => data[`customers_${month}`]);
    const shoppers = monthsOrder.map(month => data[`shoppers_${month}`]);

    setCustomersData(customers)
    setShoppersData(shoppers)
  }

  useEffect(() => {
    api.get("api/dashboard").then((response) => {
      setCustomers(response.data.data.customers)
      setCustomersVeri(response.data.data.customer_verifieds)

      setProfessionals(response.data.data.professionals)
      setAgreements(response.data.data.agreements)
    }).catch(() => {

    }).finally(() => {

    })
  }, [])

  useEffect(() => {
    api.get(`api/dashboard/data/${currentYear}`).then((response) => {
      getGraphicsData(response.data.data);
    }).catch(() => {

    }).finally(() => {

    })
  }, [])

  const screenTela =
    <div id='dashboard' className='screenContainer'>
      <h1>Dashboard</h1>
      <div className='screenSubContainer'>
        <div className='row'>
          <div className='col-12 col-sm-6'>
            <h3>Dados</h3>
            <div className='row justify-content-center justify-content-sm-start'>
              <DataCard icon={Clients} numTitle={customers} infoTitle={'Pacientes'} style={{ background: 'linear-gradient(45deg,#4099ff,#73b4ff)' }} />
              <DataCard icon={Clients} numTitle={customersVeri} infoTitle={'Pacientes Verificados'} style={{ background: 'linear-gradient(45deg,#4099ff,#73b4ff)' }} />
              <DataCard icon={Doctor} numTitle={professionals} infoTitle={'Profissionais'} style={{ background: 'linear-gradient(45deg,#2ed8b6,#59e0c5)' }} />
              <DataCard icon={Agreements} numTitle={agreements} infoTitle={'Convênios'} style={{ background: 'linear-gradient(45deg,#FFB64D,#ffcb80)' }} />
            </div>
          </div>

          <div className='col-12 col-sm-6'>
            <div className='screenSubContainer'>
              <h3>Atalhos</h3>
              <div style={{ width: 'calc(100% + 10px)' }} className='row justify-content-center justify-content-sm-start'>
                {hasRole(['Administrator', 'Receptionist']) && (<Shortcuts icon={Clients} navigate={"/customers"} infoTitle={'Pacientes'} />)}
                {hasRole(['Administrator', 'Financial', 'OnSiteSupport', 'OnlineSupport', 'ProjectManager', 'Receptionist']) && (<Shortcuts icon={Doctor} navigate={"/professionals"} infoTitle={'Profissionais'} />)}
                {hasRole(['Administrator', 'Financial', 'ProjectManager']) && (<Shortcuts icon={Agreements} navigate={"/agreements"} infoTitle={'Convênios'} />)}
                {hasRole(['Administrator', 'Finance', 'OnSiteSupport', 'OnlineSupport', 'ProjectManager']) && (<Shortcuts icon={Hospital} navigate={"/shoppers"} infoTitle={'Clientes'} />)}
                {hasRole(['Administrator', 'Receptionist']) && (<Shortcuts icon={posConsult} navigate={"/pos-consultorio"} infoTitle={'Pós'} />)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='screenSubContainer'>
        <h3>Gráficos</h3>
        <div className='row'>
          <div style={{ marginBottom: 10 }} className='col-12 col-sm-6'>
            <LineChart title='Novos Pacientes' legend='Pacientes' dataset={customersData} />
          </div>
          <div style={{ marginBottom: 10 }} className='col-12 col-sm-6'>
            <LineChart title='Novos Clientes' legend='Clientes' dataset={shoppersData} />
          </div>
        </div>
      </div>

      {
        hasRole('Administrator') ? (
          <div className='screenSubContainer'>
            <h3>Profissionais Ativos</h3>
            <div className='row justify-content-start list-agreements-dashboard'>
              <ListCardProfessionalsLoggedIn containerScrollStyle={{ height: 'auto' }} search={""} />
            </div>
          </div>
        ) : hasRole(['Financial', 'ProjectManager']) ? (
          <div className='screenSubContainer'>
            <h3>Convênios</h3>
            <div className='row justify-content-start list-agreements-dashboard'>
              <ListCardAgreements search={""} />
            </div>
          </div>
        ) : null
      }
    </div>

  return (
    <Menu screen={screenTela} />
  )
}
